const API_BASE_URLS = {
  direct: "http://57.158.24.80:8008",
  domain: "https://api.tadvn.co",
};

export const baseurl =
  window.location.hostname === "tadvn.co"
    ? API_BASE_URLS.domain
    : API_BASE_URLS.direct;
